var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTalking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "13px",
    viewBox: "0 0 22 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Contact") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Talking-Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    fill: "#70777A",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4,
    cy: 8,
    rx: 4,
    ry: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(14.000000, 0.000000)",
    fill: "#70777A",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4,
    cy: 8,
    rx: 4,
    ry: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.538252,11.076504 C11.1289393,11.076504 11.6932691,10.9636538 12.2108575,10.7583371 C12.6265823,10.5934276 13.0121531,10.3688658 13.3570079,10.0952138 C13.6095222,9.89483664 15.5690811,11.0072085 15.7737875,10.7583371 C16.1239704,10.3326029 14.6692596,8.50291066 14.8466472,7.96815765 C14.9957739,7.51860025 15.076504,7.03785388 15.076504,6.538252 C15.076504,4.94581655 14.2563208,3.54494514 13.015345,2.73502831 C12.303092,2.2701798 11.4522239,2 10.538252,2 C8.03184463,2 6,4.03184463 6,6.538252 C6,9.04465937 8.03184463,11.076504 10.538252,11.076504 Z",
    id: "Oval",
    stroke: "#FFFFFF",
    fill: "#70777A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,5.5 L12,5.5",
    id: "Line-4",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,7.5 L11,7.5",
    id: "Line-4",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalking);
export default __webpack_public_path__ + "static/media/talking.5e181a4b3a8b9ceaaf1c4cf886bf5fce.svg";
export { ForwardRef as ReactComponent };